/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: GCI 2020
  Author: Dtsmart
  Author URL: http://dtsmart.vn
==========================================================================================*/


import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker';

import * as Sentry from "@sentry/browser";
import { Vue as VueIntegration } from "@sentry/integrations";
import { Integrations } from "@sentry/tracing";

// import AOS from "aos"
// import "aos/dist/aos.css"

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css'; // Vuesax
Vue.use(Vuesax)

// Theme Configurations
import '../themeConfig.js'


// Globally Registered Components
import './globalComponents.js'


// Styles: SCSS
import './assets/scss/main.scss'


// Tailwind
import '@/assets/css/main.css'


// Vue Router
import router from './router'


// Vuex Store
import store from './store/store'


// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)

import VeeValidate from 'vee-validate';
Vue.use(VeeValidate);

// import VueApollo from 'vue-apollo';
// Vue.use(VueApollo);

// import Highcharts from "highcharts";
// import Gantt from "highcharts/modules/gantt";
// import HighchartsVue from "highcharts-vue";

// Gantt(Highcharts);
// Vue.use(HighchartsVue);


// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'


// Feather font icon
require('./assets/css/iconfont.css')


// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';
import axios from 'axios'

/* firebase */
import firebaseConfig from './firebaseConfig'
import firebase from 'firebase/app'
import 'firebase/messaging'

const token = localStorage.getItem('accessToken')
if (token) {
  axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
}

// import VueFire from 'vuefire'
// Vue.use(VueFire)
Vue.config.productionTip = false

const firebaseApp = firebase.initializeApp(firebaseConfig);
if (firebase.messaging.isSupported()){
  window.firebaseMessaging = firebaseApp.messaging();
}

const connection = {
  host: "dev-broker.dtsmart.dev",
  port: 443,
  endpoint: "/mqtt",
  clean: true, // Reserved session
  connectTimeout: 4000, // Time out
  reconnectPeriod: 4000, // Reconnection interval
  // Certification Information
  clientId: "vuejs_app_" + Math.random(),
  username: "admin",
  password: "123456abcA",
};
const { host, port, endpoint, ...options } = connection;
const connectUrl = `wss://${host}:${port}${endpoint}`;

import mqttClient from "./mqttClient.js";

Vue.prototype.$mqttClient = new mqttClient(connectUrl, options);


new Vue({
    router,
    store,
    render: h => h(App),
    created() {
      // AOS.init({
      //   disable: function () {
      //     var maxWidth = 1024;
      //     return window.innerWidth < maxWidth;
      //   }
      // });
      // AOS.refresh();
    },
}).$mount('#app')

Sentry.init({
  dsn: "https://3b02e1294645494ca89c048a40107712@sentry-01.newzen.cloud/4",
  integrations: [
    new VueIntegration({
      Vue,
      tracing: true,
      attachProps: true,
      logErrors: true
    }),
    new Integrations.BrowserTracing(),
  ],

  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 1.0,
});
